import { useEffect } from 'react'
import { reactGA, trackingId } from './GA4Tracker'

const GA = () => {
  useEffect(() => {
    reactGA.gtag('get', trackingId, 'client_id', (clientId) => {
      reactGA.set({ userId: String(clientId) })
    })
  }, [])

  return null
}

export default GA
